import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IUserInfo } from "@hero/shared/models/userInfo";
import { List, ListItem, ListItemText } from "@mui/material";
import IconHero from "../../assets/images/logo_hero_1.0_notifications.png";
import "./style.scss";
import { ISprint } from "@hero/shared/models/sprint";
import moment from "moment";
import axios from "axios";
import Url from "../../util/url";
import { getDataNotificationAction } from "../../redux/actions/notification_hero.action";
import { INotification } from "@hero/shared/models/notification";

const Notifications = () => {
    const dispatch = useDispatch();
    const userInfo: IUserInfo = useSelector(
        (state: any) => state.authState.user
    );
    const sprints: ISprint[] = useSelector(
        (state: any) => state.sprintState.sprints ?? []
    );
    const notifications: INotification[] = useSelector(
        (state: any) => state.notificationState.notifications ?? []
    );
    const sortNotification = notifications.slice().sort((a, b) => {
        const date1 = new Date(a.timestamp.toString());
        const date2 = new Date(b.timestamp.toString());
        return date2.getTime() - date1.getTime();
    });
    const activeSprint = sprints.find((sprint) => sprint.activeSprint === true);
    useEffect(() => {
        dispatch(getDataNotificationAction(userInfo._id));
    }, []);

    const handleOpenTask = (data: INotification) => {
        if (!data.isRead && data._id) {
            axios.patch(Url("notification/mark-read/" + data._id)).catch(() => {});
        }
        const url = data.actionUrl || `/task/${data.longID}`;
        window.open(url);
    };

    return (
        <>
            {sortNotification.length > 0 ? (
                <List
                    sx={{ overflow: "auto", maxHeight: "none" }}
                    className="scrollbarStyles"
                >
                    {sortNotification
                        .filter((dataft) => {
                            return (
                                dataft?.sprintID === activeSprint?._id &&
                                dataft.message
                            );
                        })
                        .map((data, index) => {
                            return (
                                <ListItem
                                    onClick={() => handleOpenTask(data)}
                                    key={index + ""}
                                    className={data.isRead ? "" : "unread"}
                                >
                                    {data &&
                                        data?.sprintID === activeSprint?._id &&
                                        data.message && (
                                            <ListItemText>
                                                <div className="container-item">
                                                    {!data.isRead && <span className="unread-dot" />}
                                                    <img
                                                        src={IconHero}
                                                        className="icon-hero"
                                                    />
                                                    <div className="container-content">
                                                        {data.shortID ? (
                                                            <span className="title">
                                                                [ {data.shortID}{" "}
                                                                ]{data.message}
                                                            </span>
                                                        ) : (
                                                            <span className="title">
                                                                {data.message}
                                                            </span>
                                                        )}
                                                        <span className="text-time">
                                                            {moment(
                                                                data.timestamp
                                                            ).format(
                                                                "DD-MM-YYYY HH:mm"
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                            </ListItemText>
                                        )}
                                </ListItem>
                            );
                        })}
                </List>
            ) : (
                <div className="text-none-data">
                    <span>Không có thông báo nào!</span>
                </div>
            )}
        </>
    );
};

export default Notifications;
